<template>
  <i-page class="qc-import" hide-close>
    <q-table bordered flat :data="main.data" :columns="main.columns" separator="cell" hide-bottom :pagination="{page:1,rowsPerPage:20}">
      <template v-slot:header="props">
        <q-tr :props="props" style="background-color:#EEEEEE">
          <q-th v-for="col in props.cols" :key="col.name" :props="props">
            <div style="font-weight:bold">
              {{ col.label }}
            </div>
          </q-th>
        </q-tr>
      </template>
      <template v-slot:body-cell="props">
        <q-td v-if="props.col.name==='rowName'" :props="props" style="background-color:#EEEEEE;">
          <div style="display:flex;">
            <span style="align-self:center;font-weight:bold">
              {{props.value}}
            </span>
          </div>
        </q-td>
        <q-td v-else-if="!props.value">
        </q-td>
        <q-td v-else-if="props.col.name==='col1'">
          <!--第一列不可以修改且不显示颜色-->
          <div :style="{display:'flex','flex-direction':'column','align-items':'center'}" @click="editItem(props.value)">
            <div>
              {{props.value.donationNo}}
            </div>
            <div>
              {{props.value.leftValue}}
            </div>
            <div>
              {{props.value.rightVale}}
            </div>
            <div>
              {{props.value.result}}
            </div>
          </div>
        </q-td>
        <q-td v-else :style="{'background-color':props.value.result==='+'?'#F44336':(props.value.result==='?'?'#03A9F4':'white')}">
          <div :style="{display:'flex','flex-direction':'column','align-items':'center'}" @click="editItem(props.value)">
            <div>
              {{props.value.donationNo}}
            </div>
            <div>
              {{props.value.leftValue}}
            </div>
            <div>
              {{props.value.rightVale}}
            </div>
            <div>
              {{props.value.result}}
            </div>
          </div>
        </q-td>
      </template>
    </q-table>

    <q-dialog v-model="dialogs.hole.show" persistent>
      <div>
        <q-form @submit="saveHole" @reset="resetHole">
          <div style="width:400px;height:300px;background-color:white;display:flex;flex-direction:column">
            <div style="margin:1em">
              <i-field v-model="dialogs.hole.model.donationNo" label="标本号" :rules="[rules.required]" :disabled="true" />
              <i-field v-model="dialogs.hole.model.leftValue" label="OD值" :rules="[rules.required]" />
              <!-- <i-field v-model="dialogs.hole.model.result" label="结果" :rules="[rules.required]" :disabled="true" /> -->
            </div>
            <q-space></q-space>
            <div class="dialog-details-actions">
              <i-btn label="取消" color="action-cancel" icon="cancel" @click="dialogs.hole.show=false" />
              <q-space></q-space>
              <i-btn label="保存" color="action-save" icon="save" type="submit" :disable="dialogs.hole.loading" />
            </div>
          </div>
        </q-form>
      </div>
    </q-dialog>
  </i-page>
</template>
<script>
import utils from '@/lib/utils'
import rules from '@/lib/rules.js'
const tableTemplates = 'ABCDEFGH'// 试管行标记
export default {
  data: function () {
    return {
      rules: rules,
      main: {
        columns: [
          { name: 'rowName', label: '', field: 'rowName', align: 'center', style: 'width:1em;padding-left:0.5em' },
          { name: 'col1', label: '1', field: 'col1', align: 'center' },
          { name: 'col2', label: '2', field: 'col2', align: 'center' },
          { name: 'col3', label: '3', field: 'col3', align: 'center' },
          { name: 'col4', label: '4', field: 'col4', align: 'center' },
          { name: 'col5', label: '5', field: 'col5', align: 'center' },
          { name: 'col6', label: '6', field: 'col6', align: 'center' },
          { name: 'col7', label: '7', field: 'col7', align: 'center' },
          { name: 'col8', label: '8', field: 'col8', align: 'center' },
          { name: 'col9', label: '9', field: 'col9', align: 'center' },
          { name: 'col10', label: '10', field: 'col10', align: 'center' },
          { name: 'col11', label: '11', field: 'col11', align: 'center' },
          { name: 'col12', label: '12', field: 'col12', align: 'center' }
        ],
        data: []
      },
      dialogs: {
        hole: {
          show: false,
          loading: false,
          model: {
            donationNo: null, result: null, leftValue: null, rightVale: null, coordinate: null
          }
        }
      }
    }
  },
  props: {
    details: {
      type: Array
    },
    fileName: {
      type: String
    },
    deviceType: {
      type: Number
    },
    testType: {
      type: Number
    }
  },
  async mounted  () {
    this.init(this.details)
  },
  methods: {
    async getResolveInfo (details) {
      const that = this
      if (details.length <= 0) return

      const items = []
      for (let index = 0; index < tableTemplates.length; index++) {
        const filteredItem = tableTemplates[index]
        that.currentMaps = details
        const row = details.filter(p => p.coordinate.includes(filteredItem))
        const data = {}
        data.rowName = filteredItem
        for (let i = 0; i < row.length; i++) {
          const current = row[i]
          data[current.coordinate.replace(filteredItem, 'col')] = { coordinate: current.coordinate, donationNo: current.donationNo, result: current.result, leftValue: current.leftValue, rightVale: current.rightVale }
        }
        items.push(data)
      }

      return items
    },
    async init (details) {
      const that = this
      if (details && details.length > 0) {
        const items = await that.getResolveInfo(details)
        if (items.length <= 0) {
          that.$q.notify({ type: 'error', message: '没有要加载的数据' })
          return
        }
        that.main.data = items
      } else {
        const rows = []
        for (const item of tableTemplates) {
          rows.push({ rowName: item })
        }
        that.main.data = rows
      }
    },
    editItem ({ donationNo, result, leftValue, rightVale, coordinate }) {
      utils.reset(this.dialogs.hole.model, {
        donationNo: donationNo,
        result: result,
        leftValue: leftValue,
        rightVale: rightVale,
        coordinate: coordinate
      })
      this.dialogs.hole.show = true
    },
    async saveHole () {
      const that = this
      that.dialogs.hole.loading = true
      // TODO:

      const result = await that.$$api.bis.post('/bis/testqc/editFileContent', {
        fileName: that.fileName,
        testType: 1,
        coordinate: that.dialogs.hole.model.coordinate,
        odValue: that.dialogs.hole.model.leftValue,
        donationNo: that.dialogs.hole.model.donationNo
      })
      result.notifyIfFail()
      that.dialogs.hole.loading = false
      if (result.success) {
        that.$emit('edit-done', result)
        result.notify({ message: '保存成功' })
        that.dialogs.hole.show = false
      }
    },
    resetHole () {

    }
  },
  watch: {
    details: {
      handler: function (newval, oldval) {
        this.init(newval)
      },
      deep: true
    }
  }
}
</script>

<style lang="scss">
.qc-import {
  position: absolute !important;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  .q-table__container {
    height: 100%;
  }
  .q-table {
    height: 100%;
  }
  .q-table thead tr,
  .q-table tbody td {
    height: auto;
  }
  .q-table thead th,
  .q-table tbody td {
    min-width: 2em;
    text-align: center;
    padding: 0;
  }
}
</style>
